import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import StartPage from './pages/StartPage';
import AboutUsPage from './pages/AboutUsPage';
import ResponsiveAppBar from './components/ResponsiveAppBar';
import Footer from './components/Footer';

/**
 * The main application component.
 *
 * @returns {JSX.Element} The rendered application component.
 */
function App() {
  return (
    <Router>
      <div className="container">
        <ResponsiveAppBar />
        <Routes>
          <Route path="/" element={<StartPage />} />
          <Route path="/about" element={<AboutUsPage />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
